import React, { useRef } from 'react';
import classNames from 'classnames';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

import IDashboardData from 'pages/Dashboard/IDashboardData';

import ScoringHashrate from '../ScoringHashrate';
import WorkerStates from '../WorkerStates';
import AverageHashrate from '../AverageHashrate';
import Loading from 'components/Loading';

const DashboardWorkerSummary = ({ data, isLoading }: { data: IDashboardData, isLoading: boolean }) => {
  const ref = useRef(null);

  return (

    <SwitchTransition>
      <CSSTransition
        nodeRef={ref}
        classNames='fade'
        timeout={300}
        mountOnEnter={true}
        unmountOnExit={true}
        key={isLoading ? 1 : 0}
      >
        <div className={classNames({
          isLoading,
          'neu-row': true,
        })}
        ref={ref}
        >
          <ScoringHashrate total={data?.scoring_hashrate_total} lastShare={data?.last_share} />
          <WorkerStates

            states={{
              workers_disabled: data?.workers_disabled,
              workers_low: data?.workers_low,
              workers_offline: data?.workers_offline,
              workers_ok: data?.workers_ok,
            }}
          />
          <AverageHashrate
            hashrates={{
              hashrate_avg_1h: data?.hashrate_avg_1h,
              hashrate_avg_5m: data?.hashrate_avg_5m,
              hashrate_avg_24h: data?.hashrate_avg_24h,
            }}
          />
          {isLoading && <Loading />}
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
};

export default DashboardWorkerSummary;
